<template>
	<div class="toggle-icon" @click="toggle">
		<Transition name="fade">
			<PlusIcon v-if="!modelValue" />
		</Transition>
	
		<Transition name="fade">
			<MinusIcon v-if="modelValue" />
		</Transition>
	</div>
</template>

<script>
	import PlusIcon from '@/components/PlusIcon.vue'
	import MinusIcon from '@/components/MinusIcon.vue'
	
	export default {
		name: 'ToggleIcon',
		components: { PlusIcon, MinusIcon },
		props: ['modelValue'],
		emits: ['update:modelValue'],
		methods: {
			toggle(){
				this.$emit('update:modelValue', !this.modelValue);
			}
		}
	}
</script>

<style scoped lang="scss">
	.toggle-icon{
		position: relative;
		width: 24px;
		height: 24px;
		cursor: pointer;
		
		svg{
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
		}
	}
</style>
